export const FAQ_ITEMS = [
  {
    q: "What types of vehicles do you work on?",
    a: "We work on cars, SUVs, and gasoline and diesel pickup trucks, including Ford F-150, F-250 and F-350; Chevrolet/GMC 1500, 2500HD and 3500HD; and Ram 1500, 2500 and 3500.\n\nWe do not work on trailers, semi-trucks, buses, or large commercial trucks.",
  },
  {
    q: "Do you work on diesel pickups?",
    a: "Yes. We diagnose and repair diesel pickups, including Cummins, Duramax and Power Stroke.",
  },
  {
    q: "Do I need an appointment?",
    a: "We recommend scheduling an appointment before bringing your vehicle. This allows us to properly organize the time needed for diagnosis and repair.",
  },
  {
    q: "Do you perform diagnostics?",
    a: "Yes. We perform mechanical, electrical and computer diagnostics. Our goal is to find the cause of the problem before recommending repairs or replacing parts.",
  },
  {
    q: "How much does a diagnostic cost?",
    a: "The cost depends on the type of problem and the time needed to find the fault. Electrical, intermittent, or programming-related problems, or issues that require additional testing, may need more diagnostic time.",
  },
  {
    q: "Can you diagnose the Check Engine light?",
    a: "Yes. A fault code does not always mean the part mentioned in the code is damaged. We use codes, live data, testing, and the vehicle's symptoms to determine the real cause of the problem.",
  },
  {
    q: "Can I bring my own parts?",
    a: "Please ask us before buying or bringing your own parts. In some cases we can install them, but warranty and labor conditions may be different.",
  },
  {
    q: "Do you offer a warranty?",
    a: "Warranty depends on the type of repair and the parts installed. Any applicable warranty will be explained at the time the work is performed.",
  },
  {
    q: "How long will the repair take?",
    a: "It depends on the diagnosis, parts availability, repair complexity, and current shop workload. After evaluating the vehicle we can give you a better estimate of the time needed.",
  },
  {
    q: "Can you inspect a vehicle that was already repaired by another shop?",
    a: "Yes, depending on the case. It is important to tell us which repairs were previously performed, which parts were replaced, and what the original problem was.",
  },
  {
    q: "Do you do engine replacements and major repairs?",
    a: "Yes. We perform major repairs and engine replacement on cars, SUVs and pickup trucks that fall within the types of vehicles we service.",
  },
  {
    q: "Do you work on electrical problems?",
    a: "Yes. We diagnose starting problems, charging system issues, wiring, sensors, modules, communication problems, and other vehicle electrical systems.",
  },
  {
    q: "Do you perform programming and relearns?",
    a: "Yes, we offer programming services and relearn procedures on compatible vehicles and modules. Availability depends on the vehicle and the system that needs service.",
  },
  {
    q: "What information should I send to request service?",
    a: "Send us your name, phone number, year, make, model, engine, mileage, and a description of the problem. You can also send photos or videos when they help explain the issue.",
  },
  {
    q: "Where are you located?",
    a: "Ascencio Auto Repair\n217 S Alliance Ct\nOklahoma City, OK 73128",
  },
  {
    q: "What are your hours?",
    a: "Monday through Friday: 8:00 AM to 6:00 PM",
  },
  {
    q: "How can I request an appointment or service?",
    a: "Complete the Request Service form on our website with your vehicle information and a description of the problem. We will review your request and contact you with the next step.",
  },
];
